/**
 * Observing if flipcard is in viewport, and trigger initial animation
 * @type {FlipCard}
 */
export class FlipCard {
    constructor() {
        this.doms = document.querySelectorAll('[data-hook-flip-card="flip-card"]')
        this.options = {
            rootMargin: '0px',
            threshold: 0.5, // 0 to 1.0
        }

        if (this.doms.length >= 1) {
            this.init()
        }
    }

    /**
     * onIntersection
     * @param entries {object}
     * @returns {undefined}
     */
    onIntersection(entries) {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                var target = entry.target

                if (!target.classList.contains('js__is-scroll-into-viewport')) {
                    target.classList.add('js__is-scroll-into-viewport')
                    var animationIsComplete

                    animationIsComplete = setTimeout(function () {
                        target.classList.add('js__is-scroll-into-viewport--animation-completed')
                        clearTimeout(animationIsComplete)
                    }, 2000)
                }
            }
        }
    }

    /**
     * init
     *
     * @returns {undefined}
     */
    init() {
        // IntersectionObserver
        for (const dom of this.doms) {
            // create new IntersectionObserver instance for each dom, preparing it for callback
            var observer = new IntersectionObserver(this.onIntersection, this.options)
            observer.observe(dom)
        }

        // Click event on touch devices
        for (const dom of this.doms) {
            dom.onclick = (event) => {
                let device = document.querySelector('html').dataset.device
                // Only touch devices
                if (device === 'touch') {
                    var currentDom = dom
                    currentDom.classList.toggle('js__touch-device-clicked')
                    for (const dom of this.doms) {
                        if (currentDom !== dom) {
                            dom.classList.remove('js__touch-device-clicked')
                        }
                    }
                }
            }
        }
    }
}
